import { render, staticRenderFns } from "./Nomination.vue?vue&type=template&id=03ff5095&scoped=true&"
import script from "./Nomination.vue?vue&type=script&lang=js&"
export * from "./Nomination.vue?vue&type=script&lang=js&"
import style0 from "./Nomination.vue?vue&type=style&index=0&id=03ff5095&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03ff5095",
  null
  
)

export default component.exports